import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { InputComponent } from '../../input/input.component';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'bis-string-only-input-keypad',
  templateUrl: './string-only-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class StringOnlyInputKeypadComponent extends InputComponent {
  @Output() onBlurOnInput = new EventEmitter();
  @Input()
  valeurParDefaut: string;
  @Input()
  longueurMax = 1000;
  @Input()
  placeholder = '';
  rootForm: UntypedFormGroup;
  libelle$: BehaviorSubject<string>;
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
   /**
   * Lorsque le champ n’est plus sélectionné, on peut le remplir automatiquement si une valeur par défaut est saisie.
   */
  public onBlur(): void {
    if (this.valeurParDefaut && this.rootForm.get(this.label).value === '') {
      this.rootForm.get(this.label).setValue(this.valeurParDefaut);
    }
    this.onBlurOnInput.emit();
  }
  ngOnInit() {
    super.ngOnInit();
    // Ajout de FormControl servant à l’affichage de la valeur
    if (! this.formAffichage) {
      (this.currentControl.parent as UntypedFormGroup).setControl(this.labelAffichage, new UntypedFormControl(this.currentControl.value));
    }
    // Mise en place de la cohérence entre nos deux formControls
    // Comme toujours avec les subscriptions, ne pas oublier de fermer les ressources
    // Cela est fait automatiquement par la classe mère via subTab
    // TODO vérifier que les filtres marchent encore avec les emitEvent à false
    this.subTab.push(
      this.currentControl.valueChanges.pipe(distinctUntilChanged() ,debounceTime(100)).subscribe((value) => {
        if (value !== '') {
        this.currentControl.setValue(this.valeurString(value));
        }
      })
    );
    // On force la mise à jour des valeurs
    this.currentControl.updateValueAndValidity();
  }

  protected valeurString (valeur: any): string {
    if(valeur !== '') {
      // pour info  le * dit que 0 à n occurrences et +  de 1 à n occurrences
      
      // Seules lettres et tiret autorises
      const regex = /[a-zA-Z \-]*/;
      //const regex = /[a-zA-Z \-]+/;

      // Rajout apostrophe, tiret et caracteres avec signes diacritiques.
      // const regex = /[a-zA-ZÀ-ÿ \'\-]*/;

      if (valeur.match(regex) !== null) {
      return valeur.match(regex)[0];
      } else return '';
    }
    else return '';
  }

  /** Retourne le FormControl servant à l’affichage qui n’est plus le même que le FormControl d’origine */
  get formAffichage (): UntypedFormControl {
    return this.currentControl.parent.get(this.labelAffichage) as UntypedFormControl;
  }
  /** Label à affecter au FormControl servant à l’affichage */
  get labelAffichage (): string {
    return this.label + '_affichage';
  }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }
}
